import {merge, map, filter, get} from 'lodash';
import {getField, inlineSchema} from './utils';
import i18n from '../i18n/index';
import moment from 'moment';
import * as Subprofile from './subprofile';
import * as Appointment from './appointment';
import * as Member from './membership';
import * as Group from './group';
import * as Product from './product';
import * as Transaction from './transaction';
import * as Profile from './profile';
import * as ServiceLocation from './service_location';
import * as EmergencyContact from './emergency_contact';
import * as UserExperience from './user_experience';
import * as MedicalHistory from './medical_history';

export default function () {
  return {
    // a set of tickets
    order_id: {type: 'id'},
    status: {type: 'select', items: ['status.active', 'status.inactive'], default: 'active'},
    created_by: {type: 'schema', schema: Member, list: true, readonly: true},
    created_at: {type: 'datetime', readonly: true},
    updated_at: {type: 'datetime', readonly: true},
    // type: {type: 'string'},
    tags: {type: 'tags'}, // copy from subProfile


    required_groups: {
      type: 'array',
      readonly: true,
      itemType: {
        type: 'schema', schema: merge(inlineSchema({
          group: {type: 'schema', required: true, schema: Group},
          required_self_status: {type: 'select', items: ['status.pending', 'status.approved', 'status.admin']},
        }), {
          title(model) {
            return Group.title.call(this, model.group, Group);
          },
        }),
      },
    },
    product: {type: 'schema', schema: Product, readonly: true, list: true},
    //  include price_options of
    //  - product
    //  - customs
    //  - additional_item

    total_tickets: {type: 'number'},
    available_tickets: {type: 'number'},
    unit_amount: {type: 'number', readonly: true},
    location_fee: {type: 'number', readonly: true},

    custom_ids: {
      type: 'array', itemType: {
        type: 'select',
        items(value, model, spec, search) {
          return Promise.resolve(
            this.rootModel
              ? map(filter(this.rootModel.product.customs, x => x.type === 'timeslot'), x => {
                let parts = x.custom_id.replace(/\.[a-z0-9\-]{36}$/i, '');
                parts = parts.split('-');
                let start = moment(parts[1], 'HHmm');
                return {
                  value: x.custom_id,
                  label: `${moment.duration(parseInt(parts[0]), 'm').humanize()}, ${start.format('HH:mm')}~${start.add(parseInt(parts[0]), 'm').format('HH:mm')}, cool down ${moment.duration(parseInt(parts[2]), 'm').humanize()}`,
                };
              })
              : []);
        },
      },
    }, // customs, timeslot
    // additional_item_ids: {type: 'array', add: true, delete: true, itemType: {type: 'string'}},

    //  can be the member himself ( type = myself)
    subProfile: {type: 'schema', schema: Subprofile, readonly: true},
    // 'subProfile.details': {
    //   label: 'schema.subprofile',
    //   readonly: true,
    //   type: 'schema', schema: merge(inlineSchema({
    //     "profile": {type: 'schema', schema: Profile},
    //     "relationship": {type: 'string'},
    //     "medical_history": {
    //       type: 'schema', add: true, delete: true,
    //       schema: MedicalHistory,
    //     },
    //   }), {
    //     title(model) {
    //       return i18n.nn`${Profile.title.call(this, model.profile, Profile)} (${model.relationship})`;
    //     },
    //   }),
    // },
    details: {
      type: 'schema', schema: inlineSchema({
        // expected_start_date: {type: 'datetime'},
        remark: {type: 'text'},
      }),
    },

    service_location: {type: 'schema', schema: ServiceLocation},

    emergency_contact: {type: 'schema', schema: EmergencyContact},

    // stat: {}, //    member pofile and bid profile will be load in main page, use so search algorithm

    transactions: {
      type: 'array',
      itemType: {type: 'schema', schema: Transaction, readonly: true},
    },

    appointments: {
      type: 'array',
      itemType: {
        type: 'schema', schema: merge({}, Appointment, {
          title(model) {
            let name = get(model, 'subprofile');
            name = name ? Subprofile.title.call(this, name, Subprofile) : null;
            name = name || i18n.s('schema.appointment');
            let time = moment(get(model, 'details.service_begin'));
            if (time.isValid()) time = ` (${time.format('DD/MM/YYYY HH:mm')})`;
            else time = '';
            return name + time;
          },
        }), external: true,
      },
    },

    service_date: {
      type: 'array', hidden: true, list: true,
      itemType: {type: 'date'},
      get(model) {
        return get(model, 'appointments', [])
          .map(x => moment(get(x, 'details.service_date')))
          .filter(x => x.isValid());
      },
      display(model, index, fieldSpec) {
        let value = getField.call(this, model, fieldSpec);
        return {template: `<div>${value.map(x => x.format('DD/MM/YYYY')).join('<br>')}</div>`};
      },
    },
    // records: [{}],

    /* when client re-order */
    /* y is total of ticket purchased in new transaction   */
    expiry_date: {type: 'datetime'},
    // *** new_expiry_date  = (last_purchase_date + y month)
    // expiry_date = pick_latest(last_purchase_date, expiry_date)


  };
}



// WEBPACK FOOTER //
// ./src/schemas/order_db.js